module.exports = __webpack_public_path__ + "img/smile.4ad18650.svg";